<div class="create-call-container"  [ngClass]="{ 'readonly': ReadOnly == true  }">
  <div *ngIf="isTwilio">
    <div class="row mb-2">
      <div>
        <span class="info">Choose a number to dial:</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <div class="input-data">
          <select
            name="phoneNumber"
            class="drpdown-input-box"
            [(ngModel)]="selectedNumber"
            (change)="OnChangeSelectedNumber()"
          >
            <option value="select">Select</option>
            <option [ngValue]="option.value" *ngFor="let option of numberList">
              {{ option.name }}
            </option>
          </select>
          <div class="underline"></div>
        </div>
      </div>
      <div class="col-md-3 p-0">
        <img
          src="{{ baseHref }}/assets/images/icon-dial-call-green.svg"
          class="call"
          [class.disabled]="!isPhoneNumberAvailable()"
          alt="call"
          tabindex="1"
          (click)="isPhoneNumberAvailable() && StartOutboundCall()"
          (keydown.enter)="isPhoneNumberAvailable() && StartOutboundCall()"
        />
        <img
          src="{{ baseHref }}/assets/images/icon-dialer-circle.svg"
          class="numpad"
          alt="numpad"
          tabindex="2"
          (click)="toggleNumpad()"
          (keydown.enter)="toggleNumpad()"
        />
        <!-- <button class="btn submit text-center" type="submit" (click)="StartOutboundCall()">Call</button> -->
      </div>
      <!-- <div class="col-md-2">
      <button class="btn submit text-center" type="submit">Dial Manually</button>
    </div>
    <div class="col-md-2">
      <button class="btn submit text-center" type="submit">Add Prior Conversation</button>
    </div> -->
    </div>
  </div>
  <div *ngIf="isEnableAddNewNumber" class="row mt-3 add_number">
    <div class="col-md-5">
      <div class="input-data">
        <select name="phoneNumberType" class="drpdown-input-box" [(ngModel)]="selectedType" (change)="onSelectionChange($event)" >
          <option [value]="option.type" *ngFor="let option of numberTypeList">
            {{ option.name }}
          </option>
        </select>
        <!-- <div class="underline"></div> -->
      </div>
    </div>
    <div class="col-md-7 g-0">
      <div class="input-data">
        <input type="text" [(ngModel)]="phoneNumber"   (keydown.enter)="isPhoneNumberAvailable() && StartOutboundCall()"/>
        <!-- <div class="underline"></div> -->
      </div>
    </div>
  </div>
  <div *ngIf="isEnableAddNewNumber" class="row add_number mt-2 ps-2">
    <label for="SaveUserRecord">Save to user record</label>
    <input type="checkbox" [(ngModel)]="IsSaveUserRecord" name="SaveUserRecord" />
  </div>

  
</div>
